import { useEffect, type ReactNode } from "react";

// STRIKZA is a DARK-MODE-ONLY interface (founder decision, 2026-06-02).
// Light mode was removed. This provider hard-pins the dark theme so any
// stale `sz-theme=light` left in a user's localStorage can never resurface
// a light UI, and so the dead [data-theme="light"] CSS never matches.

type Theme = "dark";

interface ThemeCtx {
  theme: Theme;
  /** No-op — kept for back-compat with components that still call it. */
  toggle: () => void;
}

export function useTheme(): ThemeCtx {
  return { theme: "dark", toggle: () => {} };
}

export function ThemeProvider({ children }: { children: ReactNode }): JSX.Element {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "dark");
    try {
      localStorage.setItem("sz-theme", "dark");
    } catch {
      /* SSR or private browsing — noop */
    }
  }, []);

  return <>{children}</>;
}
